// extracted by mini-css-extract-plugin
export var bounce = "ScrollDownButton-module--bounce--YU1iA";
export var disc = "ScrollDownButton-module--disc--a1m3s";
export var icon = "ScrollDownButton-module--icon--o4UEh";
export var wrapper = "ScrollDownButton-module--wrapper--blLGE";